import { Injectable, computed, inject } from '@angular/core';
import { SessionService } from 'src/app/auth/services/session.service';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { Role } from 'src/app/pages/anvandare/anvandare.models';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Router } from '@angular/router';
import { AnvandareService } from 'src/app/pages/anvandare/anvandare.service';
import { StandardNameUpdateStateService  } from 'src/app/pages/startsida/standard-name-update-state.service';
import { MenuItemCommandEvent } from 'primeng/api';
import { StartService  } from 'src/app/pages/startsida/start.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private auth = inject(AuthService);
  private router = inject(Router);
  private sessionService = inject(SessionService);
  private authorizationService = inject(AuthorizationService);
  private anvandareService = inject(AnvandareService);
  private standardNameUpdateState = inject(StandardNameUpdateStateService);
   private updatesInProgress = false;

  public menuSections = computed(() =>
      [
        {
          label: 'Startsida',
          icon: 'fas fa-house',
          routerLink: 'startsida',
        },
        {
          label: 'Åtgärdslista',
          icon: 'fas fa-list',
          routerLink: 'atgardslista',
          visible: this.authorizationService.hasRole([Role.SuperanvandareIntern]),
        },
        {
          label: 'Larm',
          icon: 'fas fa-bell',
          items: [
            {
              label: 'Utlösta larm',
              routerLink: 'larm-nya',
              state: {
                isSubMenuItem: true,
              },
            },
            {
              label: 'Larmkriterier',
              routerLink: 'larm-kriterium',
              state: {
                isSubMenuItem: true,
              },
            },
          ],
          visible: this.authorizationService.hasRole([
            Role.BasanvandareIntern,
            Role.BasanvandareExtern,
            Role.SuperanvandareIntern,
            Role.SuperanvandareExtern,
          ]),
        },
        {
          label: ' Analysresultat 14 d',
          icon: 'fas fa-hourglass-half',
          routerLink: 'inskicksresultat',
          visible: this.authorizationService.hasRole([Role.SuperanvandareIntern]),
        },
        {
          label: 'Analysresultat',
          icon: 'fas fa-magnifying-glass-chart',
          items: [
            {
              label: 'Sök specifikt smittämne',
              routerLink: 'analysresultat',
              state: {
                isSubMenuItem: true,
              },
              styleClass: this.standardNameUpdateState.updatesInProgress() ? 'menu-item-disabled' : '',
              title: this.standardNameUpdateState.updatesInProgress()
                  ? 'Standard name update in progress'
                  : undefined,
            },
            {
              label: 'Sök nämnardata',
              routerLink: 'namnardata-search',
              state: {
                isSubMenuItem: true,
              },
              styleClass: this.standardNameUpdateState.updatesInProgress() ? 'menu-item-disabled' : '',
            },
            {
              label: 'Generell sökning',
              routerLink: 'generalSearch',
              state: {
                isSubMenuItem: true,
              },
              styleClass: this.standardNameUpdateState.updatesInProgress() ? 'menu-item-disabled' : '',
            },
          ],
          visible: this.authorizationService.hasRole([
            Role.BasanvandareIntern,
            Role.BasanvandareExtern,
            Role.SuperanvandareIntern,
            Role.SuperanvandareExtern,
          ]),
        },
        {
          label: 'Namnlistor',
          icon: 'fas fa-database',
          items: [
            {
              label: 'Standardnamn',
              routerLink: 'standardnamn',
              state: {
                isSubMenuItem: true,
              },
            },
            {
              label: 'Synonymer',
              routerLink: 'synonymer',
              state: {
                isSubMenuItem: true,
              },
            },
            {
              label: 'Ignorerade',
              routerLink: 'ignorerade',
              state: {
                isSubMenuItem: true,
              },
            },
          ],
          visible: this.authorizationService.hasRole([
            Role.BasanvandareIntern,
            Role.BasanvandareExtern,
            Role.SuperanvandareIntern,
            Role.SuperanvandareExtern,
          ]),
        },
        {
          label: 'Användare',
          icon: 'fas fa-user',
          items: [
            {
              label: 'Användarlista',
              routerLink: 'anvandare',
              state: {
                isSubMenuItem: true,
              },
            },
            {
              label: 'Ny användare',
              routerLink: 'lagg-till-anvandare',
              state: {
                isSubMenuItem: true,
              },
              visible: this.authorizationService.hasRole([
                Role.Systemadministrator,
                Role.BehorighetsadministratorExtern,
              ]),
            },
          ],
      visible: this.authorizationService.hasRole([
        Role.Systemadministrator,
        Role.BehörighetsadministratörIntern,
        Role.BehorighetsadministratorExtern,
      ]),
    },
    {
      label: 'Logga ut',
      icon: 'fas fa-right-from-bracket',
      command: this.logout.bind(this),
    },
  ]);

  private logout() {
    this.auth.logout();
    this.router.navigate(['/']);
    this.sessionService.logout();
  }

  get menu() {
    return this.menuSections();
  }
}
